import styled, { css } from "styled-components";
import { COLOR_BLACK, COLOR_RED, COLOR_WHITE } from "../constants/colors";
import { Body1, Body2, Subtitle2 } from "./Typography";

type InputProps = {
  type?: string;
  label: string;
  value: string;
  placeholder: string;
  error?: string;
  onChange: (value: string) => void;
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  ${Body1}
  color: ${COLOR_WHITE};
`;

const StyledInput = styled.input<{ hasError: boolean }>`
  ${Subtitle2}
  color: ${COLOR_BLACK};
  border-radius: 12px;
  padding: 6px 20px;
  border: 2px solid ${COLOR_WHITE};
  outline: none;

  ${(props) =>
    props.hasError &&
    css`
      border: 2px solid ${COLOR_RED};
      ::placeholder {
        color: ${COLOR_RED};
      }
      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: ${COLOR_RED};
      }
      ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: ${COLOR_RED};
      }
    `}

  @media (max-width: 768px) {
    border-radius: 8px;
    padding: 6px 16px;
  }
`;

const Error = styled.div`
  ${Body2}
  color: ${COLOR_WHITE};
`;

function Input(props: InputProps) {
  const { type, label, value, error, placeholder, onChange } = props;

  const onInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <InputWrapper>
      <Label className="mb-2">{label}</Label>
      <StyledInput
        onChange={onInputChanged}
        hasError={!!error}
        value={value}
        placeholder={placeholder}
        onKeyPress={(event) => {
          if (type !== "number") return;
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
      {error && <Error className="mt-1">{error}</Error>}
    </InputWrapper>
  );
}

export default Input;

Input.defaultProps = {
  type: "text",
  error: "",
};
